__turbopack_context__.v({
  "active": "MobileNavigation-module-scss-module__nn_YHW__active",
  "chevron": "MobileNavigation-module-scss-module__nn_YHW__chevron",
  "divider": "MobileNavigation-module-scss-module__nn_YHW__divider",
  "divider-primary": "MobileNavigation-module-scss-module__nn_YHW__divider-primary",
  "divider-secondary": "MobileNavigation-module-scss-module__nn_YHW__divider-secondary",
  "expandableItem": "MobileNavigation-module-scss-module__nn_YHW__expandableItem",
  "itemHeader": "MobileNavigation-module-scss-module__nn_YHW__itemHeader",
  "itemLabel": "MobileNavigation-module-scss-module__nn_YHW__itemLabel",
  "itemLabel-primary": "MobileNavigation-module-scss-module__nn_YHW__itemLabel-primary",
  "itemLabel-secondary": "MobileNavigation-module-scss-module__nn_YHW__itemLabel-secondary",
  "menuItem": "MobileNavigation-module-scss-module__nn_YHW__menuItem",
  "menuItems": "MobileNavigation-module-scss-module__nn_YHW__menuItems",
  "menuLink": "MobileNavigation-module-scss-module__nn_YHW__menuLink",
  "mobileNav": "MobileNavigation-module-scss-module__nn_YHW__mobileNav",
  "nestedItem": "MobileNavigation-module-scss-module__nn_YHW__nestedItem",
  "nestedLink": "MobileNavigation-module-scss-module__nn_YHW__nestedLink",
  "nestedLinkSecondary": "MobileNavigation-module-scss-module__nn_YHW__nestedLinkSecondary",
  "nestedMenu": "MobileNavigation-module-scss-module__nn_YHW__nestedMenu",
});
